<template>
    <div class="past-users panel panel-default">
        <div class="panel-heading">
            <div class="row">
                <div class="col-sm-3">
                    <h4>Estadísticas históricas</h4>
                    <h5>{{ procedureId ? 'Ficha ChileAtiende' : 'Portal ChileAtiende' }}</h5>
                </div>
                <div class="col-sm-2">
                    <select v-if="showTypePicker" class="form-control" v-model="type">
                        <option value="activeUsers">Visitas únicas</option>
                    </select>
                </div>
                <div class="col-sm-4">
                    <div class="btn-group" role="group">
                        <button type="button" class="btn btn-default" :class="{ active: period == 'date' }"
                            @click="period = 'date'">Por Día</button>
                        <button type="button" class="btn btn-default" :class="{ active: period == 'yearMonth' }"
                            @click="period = 'yearMonth'">Por mes</button>
                        <button type="button" class="btn btn-default" :class="{ active: period == 'year' }"
                            @click="period = 'year'">Por Año</button>
                    </div>
                </div>
                <div class="col-sm-3 date-picker-wrapper">
                    <div class="text-right">
                        <el-date-picker v-if="showDatePicker" v-model="range" format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd" type="daterange" :clearable="false"
                            :picker-options="pickerOptions" range-separator=" / " class="date-picker" size="small">
                        </el-date-picker>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-body">
            <div ref="chartWrapper">
                <area-chart v-show="!loading" :data="chartData" :height="chartHeight" :width="chartWidth"
                    :y-tick-format="yTickFormat">
                </area-chart>
            </div>
            <div class="loader" v-show="loading">
                <img src="../../images/loader.svg" alt="Cargando contenido" />
            </div>
        </div>
    </div>
</template>

<script>
import ElDatePicker from 'element-ui/lib/date-picker';
import AreaChart from './AreaChart.vue';
import moment from 'moment';
import axios from 'axios';

export default {
    data() {
        return {
            refreshInterval: 60 * 60 * 1000,
            type: 'activeUsers',
            analyticsData: [],
            range: [
                moment('2024-01-01').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            period: 'yearMonth',
            loading: true,
            chartWidth: 810,
            chartHeight: 400,
            pickerOptions: {
                disabledDate(date) {
                    return date < moment('2023-04-01').toDate() || date > moment().toDate();
                }
            }
        }
    },
    props: {
        procedureId: { default: null },
        showDatePicker: { default: true },
        showTypePicker: { default: true }
    },
    components: {
        AreaChart,
        ElDatePicker
    },
    computed: {
        yTickFormat() {
            if (this.period === 'year') return 'YYYY';
            if (this.period === 'yearMonth') return 'MMM YY';
            return 'DD-MM-YY';
        },
        chartData() {
            if (!this.analyticsData || !this.analyticsData.length) return [];

            return this.analyticsData.map(item => ({
                date: item.date,
                value: parseInt(item.screenPageViews)
            }));

        }
    },
    methods: {
        async refresh() {
            this.loading = true;
            try {
                const params = {
                    dimensions: this.period
                };

                if (this.period !== 'year') {
                    params.start = this.range[0];
                    params.end = this.range[1];
                } else {
                    // Para vista anual, siempre usar rango desde 2023 hasta el año actual
                    params.start = '2023-04-01';
                    params.end = moment().format('YYYY-12-31');
                }

                if (this.procedureId) {
                    params.procedureId = this.procedureId;
                }

                const response = await axios.get('backend/api/analytics/ga4', { params });

                if (response.data && response.data.analytics) {
                    this.analyticsData = response.data.analytics;
                }
            } catch (error) {
                console.error('Error al obtener datos de GA4:', error);
                this.analyticsData = [];
            } finally {
                this.loading = false;
            }
        },
        updateChartDimensions() {
            if (this.$refs.chartWrapper) {
                const rect = this.$refs.chartWrapper.getBoundingClientRect();
                this.chartWidth = rect.width || 810;
                this.chartHeight = 400;
            }
        }
    },
    watch: {
        range: {
            handler(newValue) {
                if (Array.isArray(newValue) && newValue[0] && newValue[1]) {
                    this.refresh();
                }
            },
            deep: true
        },
        period() {
            this.refresh();
        }
    },
    mounted() {
        this.refresh();
        this.updateChartDimensions();
        window.addEventListener('resize', this.updateChartDimensions);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateChartDimensions);
    }
}
</script>

<style lang="scss">
@import "../../sass/variables";

.past-users {
    .panel-heading {
        .el-date-editor {
            width: 100%;

            .el-range-input {
                width: 42% !important;
            }

            .el-range-separator {
                padding: 0 5px;
            }
        }
    }

    .panel-body {
        padding: 14px;
        min-height: 330px;

        .loader {
            text-align: center;
        }
    }
}
</style>